<template>
  <div class="page pa-9 ai-expert-page">
    <h2 class="page-title mb-8 mt-1">AI-эксперт</h2>
    <!-- <div class="profile-board ref-board"> -->
    <v-card class="mb-4 pa-4">
      <v-tabs v-model="tab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="(t, ind) in tabs" :key= "ind" :disabled="!t.component" class="text-none no-spacing font-weight-bold">
          {{ t.title }}
          </v-tab>
      </v-tabs>
    </v-card>
    <v-tabs-items v-model="tab" class="transparent">
      <v-tab-item v-for="(t, ind) in tabs" :key="ind" >
        <component :is="t.component" v-bind="t.props || {}" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import ExpertTab from './expert/ExpertTab.vue'
import HRProjectsTable from './hr-projects/HRProjectsTable.vue'

export default {
  name: 'Analytics',
  components: {
    ExpertTab, HRProjectsTable
  },
  data() {
    return {
      tab: 0,
      tabs: [
        {
          title: 'Диалог с AI-экспертом',
          component: ExpertTab,
          props: { fromMainMenu: true },
        },
        {
          title: 'Проекты HR',
          component: HRProjectsTable,
        },
        {
          title: 'Проекты от AI-эксперта',
          component: null// ProjectsTab,
        },
        {
          title: 'Сравнение кандидатов',
          component: null,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
    }),
  },
  watch: {
    tab(newTab) {
      const routeTab = Number(this.$route.query.tab)
      if (newTab != routeTab) {
        this.$router.push({
          query: {
            ...this.$route.query,
            tab: newTab
          }
        })
      }
    }    
  },  
  methods: {
    ...mapActions({
    }),
  },
  async mounted() {
    const initialTab = this.$route.query.tab
    if (initialTab !== undefined) {
      this.tab = Number(initialTab)
    }
  },
};
</script>

<style lang="scss">

.no-spacing {
  letter-spacing: 0;
}

.ai-expert-page {
  background-color: #F5F8FF;
}

.ai-back {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #9BA1B5 !important;
}

.ai-breadcrumps {
  font-weight: 600 !important;
  font-size: 13px !important;
  line-height: 20px !important;
  color: #818181 !important;
}

</style>
